/**
 * H3DynamicLegend - Динамическая легенда для H3-слоев
 *
 * Автоматически масштабирует значения легенды в зависимости от h3_zoom уровня
 * так как разные размеры ячеек H3 содержат разные объёмы данных.
 *
 * LEGACY: Этот компонент используется для старых H3-слоев.
 * Для новых слоев используйте DynamicGradientLegend с type: LEGEND_TYPES.GRADIENT, isDynamic: true
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
    scaleH3LegendValues,
    formatH3LegendValue,
} from '../../../utils/scaleH3LegendValues';
import styles from '../../FilterSidebar/FilterSidebar.module.css';

// Цвета для legacy H3-слоев (viridis palette)
const LEGEND_COLORS = [
    'hsla(240, 100%, 27%, 0.4)',
    '#0d0887',
    'rgb(127,3,168)',
    'rgb(203,71,120)',
    '#f07f4f',
    '#f0f921',
];

export const H3DynamicLegend = ({ renderConfig = {} }) => {
    // Получаем текущий h3_zoom из Redux
    const aggTracksAugustH3Zoom = useSelector(
        state => state.mapFilters?.aggTracksAugustH3Zoom || 'auto'
    );
    // Получаем масштабированные значения легенды
    const scaledValues = scaleH3LegendValues(aggTracksAugustH3Zoom);
    // Извлекаем класс контейнера из конфига
    const containerClass = renderConfig.containerClass || styles.legendContainer || '';

    return (
        <div className={containerClass}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    padding: '4px 0',
                }}
            >
                {/* Рендерим каждое значение с соответствующим цветом */}
                {scaledValues.map((value, index) => (
                    <div
                        key={`h3-legend-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        {/* Цветная полоса */}
                        <div
                            style={{
                                width: '20px',
                                height: '16px',
                                backgroundColor: LEGEND_COLORS[index],
                                borderRadius: '2px',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                            }}
                        />
                        {/* Значение и текст */}
                        <div
                            style={{
                                fontSize: '12px',
                                color: '#333',
                            }}
                        >
                            {formatH3LegendValue(value)}
                        </div>
                    </div>
                ))}

                {/* Показываем текущий h3_zoom уровень */}
                <div
                    style={{
                        fontSize: '11px',
                        color: '#666',
                        marginTop: '6px',
                        borderTop: '1px solid #ddd',
                        paddingTop: '6px',
                    }}
                >
                    {aggTracksAugustH3Zoom === 'auto'
                        ? 'Автоматический зум'
                        : `H3 Zoom: ${aggTracksAugustH3Zoom}`}
                </div>
            </div>
        </div>
    );
};

H3DynamicLegend.propTypes = {
    renderConfig: PropTypes.shape({
        containerClass: PropTypes.string,
    }),
};

export default H3DynamicLegend;
